import type { DhChatReplyTo, MessengerMessage } from '@/api/messenger/types'

export function messageReplyQuote(message: MessengerMessage): DhChatReplyTo {
    return {
        available: true,
        messageId: message.id,
        direction: message.type === 'incoming' ? 'in' : 'out',
        text: message.text || null,
        media: message.media ? { ...message.media, originalName: message.media.originalName || null } : null,
        createdAt: message.createdAt,
        quoteText: null,
    }
}
